<template>
  <section class="doc-content">
    <div v-if="loading" class="loading">Loading API documentation...</div>
    <div v-else-if="error" class="error">{{ error }}</div>
    <iframe
      v-else
      ref="scalarIframe"
      src="/dist/js/vendor/scalar/scalar.html"
      class="scalar-iframe"
    ></iframe>
  </section>
</template>

<script>
import WebResourceSecure from '../../assurance/services/web-resource-secure.service';
import DataProvider from  '../../../app/data-framework/data-provider';

export default {
  name: 'ApiDocumentation',
  data() {
    const dataProvider = DataProvider.getInstance();
    return {
      specContent: null,
      loading: true,
      error: null,
      dataProvider
    };
  },
  mounted() {
    // The viewer iframe (scalar.html/scalar-init.js) posts an API_DOC_VIEWER_READY
    // message once it has loaded and is ready to receive the spec, since it is
    // served as a real page rather than an iframe srcdoc (see scalar-init.js for why).
    window.addEventListener('message', this.onViewerMessage);
    this.loadApiSpec();
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onViewerMessage);
  },
  methods: {
    async loadApiSpec() {
      try {
        // fetch the OpenAPI spec with auth token
        const serviceUrl = await this.dataProvider.fetchApiGatewayBaseURL();
        this.specContent = await WebResourceSecure.getJSON(
          serviceUrl + '/docs/wxpc-query-service',
          {},
          'GET'
        );
        this.loading = false;
      } catch (e) {
        console.error('Failed to load API specification:', e);
        this.error = 'Failed to load API documentation. Please try again later.';
        this.loading = false;
      }
    },
    onViewerMessage(event) {
      const iframe = this.$refs.scalarIframe;
      const isFromViewer =
        iframe &&
        event.origin === window.location.origin &&
        event.source === iframe.contentWindow;

      if (!isFromViewer || !event.data || event.data.type !== 'API_DOC_VIEWER_READY') {
        return;
      }

      // The iframe only mounts once specContent has already been fetched
      // (loading becomes false), so it should always be available by the
      // time the viewer signals it's ready - but guard anyway in case the
      // viewer somehow reloads or sends a duplicate ready message.
      if (this.specContent) {
        event.source.postMessage({ type: 'API_DOC_SPEC', spec: this.specContent }, window.location.origin);
      }
    }
  }
};
</script>

<style scoped>
.doc-content {
  padding: 0;
  width: 100%;
  min-height: calc(100vh - 36px);
}

.scalar-iframe {
  border: none;
  width: 100%;
  min-height: calc(100vh - 36px);
  display: block;
}

.loading,
.error {
  padding: 2rem;
  text-align: center;
}

.error {
  color: #d32f2f;
}
</style>
